// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { Typography, Button } from '@material-ui/core';
import qs from 'query-string';
import { getI18n } from "../../../utils/intl";
import { useIntl } from "react-intl";

import { xssSanitize } from "../../../utils";

import { useGlobalVariable } from "../hooks";
import { FormTextField } from '../../../components';
import BrandLogo from '../BrandLogo';

const AuthHubAuthScheme = ({ classes, scheme: authScheme }) => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const intl = getI18n(useIntl());

  const [showOnlyOktaParam] = useGlobalVariable('fromApiHub', 'fromApiHub', false);
  const [referrer] = useGlobalVariable('referrer', 'referrer', false, true);
  const [loginHint, setLoginHint] = useState('');

  let referrerURL;
  if (showOnlyOktaParam) {
    referrerURL = urlSearchParams.get('fromUrl');
  } else {
    const redirectPath = referrer ? xssSanitize(referrer) : '';
    referrerURL = redirectPath ? (window.location.origin + redirectPath) : '';
  }
  const relayState = {
    "tenantId": authScheme.tenantId,
    "tenantDomainName": window.location.host,
  };
  if (referrerURL) {
    relayState.fromUrl = referrerURL;
  }
  const config = {
    login_hint: loginHint,
    RelayState: JSON.stringify(relayState),
    signin_hint: true,
  };

  const handleSubmit = () => {
    const queryString = qs.stringify(config);
    window.location.href = `${authScheme.samlProxySSOUrl}&${queryString}`
  };

  return (
    <>
      <BrandLogo classes={classes} hideProviderInfo={true} />
      <div>
        <Typography
          className={classes.aHubHeaderText}
          data-apim-test='auth-hub-title'
          id='auth-hub-title'
          variant='h1'
        >
          {intl.getI18nMessage('label.login.ahub.email.title')}
        </Typography>
        <FormTextField
          handleChange={setLoginHint}
          id={'authhub-login-hint'}
          name={intl.getI18nMessage('label.login.ahub.email.label')}
          value={loginHint}
        />
      </div>
      <Button
        classes={{
          root: classes.buttonStyles, startIcon: classes.buttonIcon,
        }}
        color="secondary"
        data-apim-test="login-submit"
        onClick={handleSubmit}
        type='submit'
        variant="contained"
      >
        <Typography className={classes.buttonContent} color="inherit" >
        {intl.getI18nMessage('label.login.ahub.email.next')}
        </Typography>
      </Button>
    </>
  );
};

AuthHubAuthScheme.propTypes= {
  classes: PropTypes.shape(),
  scheme: PropTypes.shape(),
}

export default AuthHubAuthScheme;
